<template>
    <div class="p-2 row">
        <div class="col-20">
            <h4 class='section-heading'>{{ $t('translations.subtitle_user_details')}}</h4>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.name')}}:</div><div class="col-14"> {{this.item.name}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.practice_code')}}:</div><div class="col-14"> {{this.item.practice_code}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.demo_mode')}}:</div> <div class="col-14"> {{this.item.demo_mode ? "On" : "Off"}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.service_availability')}}:</div> <div class="col-14"> {{this.item.service_status ? "On" : "Off"}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.video_available')}}:</div> <div class="col-14"> {{this.item.video_available ? "Yes" : "No"}}</div>
            </div>

            <div v-if='item.video_available' class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.video_enabled')}}:</div> <div class="col-14"> {{this.item.video_enabled ? "Yes" : "No"}}</div>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.appointment_booking_enabled')}}:</div> <div class="col-14"> {{this.item.appointment_booking_enabled ? "Yes" : "No"}}</div>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.clinician_gender_selection_enabled')}}:</div> <div class="col-14"> {{this.item.clinician_gender_selection_enabled ? "Yes" : "No"}}</div>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.campaigns_enabled')}}:</div> <div class="col-14"> {{this.item.campaigns_enabled ? "Yes" : "No"}}</div>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.reports_enabled')}}:</div> <div class="col-14"> {{this.item.reports_enabled ? "Yes" : "No"}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ autobrand('translations.patient_link')}}:</div><div class="col-14"><a target='patient' :href='patient_link' v-text='patient_link'></a></div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ autobrand('translations.time_requests_return_waiting')}}:</div><div class="col-14"> {{this.item.wait_exit_time}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.set_waiting_days')}}:</div><div class="col-14"> {{this.item.wait_default_days}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ capitalise($t('translations.list_size')) }}:</div><div class="col-14"> {{this.item.practice_list_size}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.practice_type')}}:</div><div class="col-14"> {{$root.lookup.practice_types[this.item.practice_type_id]}}</div>
            </div>

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.practice_status')}}:</div><div class="col-14"> {{$root.lookup.practice_operational_statuses[this.item.practice_operational_status_id]}}</div>
            </div>
            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.provider_type')}}:</div><div class="col-14"> {{$root.lookup.provider_types[this.item.provider_type_id]}}</div>
            </div>
            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.sms_smtp_gateway_domain')}}:</div><div class="col-14"> {{this.item.sms_smtp_gateway_domain}}</div>
            </div>
            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.record_system_integration_type')}}:</div><div class="col-14"> {{$root.lookup.record_system_integration_types[this.item.record_system_integration_type_id]}}</div>
            </div>
            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.provider_url')}}:</div><div class="col-14"> {{this.item.provider_url}}</div>
            </div>
            <!-- <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.record_system_test_user_id')}}:</div><div class="col-14"> {{this.item.record_system_test_user_id}}</div>
            </div> -->

            <div class="form-group d-flex border-bottom">
                <div class="col-10">{{ $t('translations.network')}}:</div><div class="col-14">
                    <ul class='pl-3' v-if='$parent.item.provider_provider_xref && $parent.item.provider_provider_xref.length'>
                        <li :key='xref.relation_id' v-for='(xref, index) in $parent.item.provider_provider_xref'>
                            {{ $parent.item.provider_provider_xref[index].relation.name }}
                        </li>
                    </ul>
                    <template v-else>
                        None
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        data() {
            return {
                item: {name: "", email: "", provider_url: "" },
                errors: [],
                itemName: "",
                document_download: {name: null, data: null},
            }
        },
        props: {
            item: {

            }
        },
        computed: {
            patient_link() {
                if(this.$parent.item && typeof this.$parent.item.provider_url == "string") {
                    return window.location.protocol + "//" + this.$parent.item.provider_url.replace(/(admin|provider|nhs)\./, "my.") + ((window.location.port && window.location.port !== "443") ? `:${window.location.port}` : "") + "/?c=" + this.$parent.item.practice_code;
                }
                return "";
            },
        },
        methods: {
            
        }
    };
</script>
